<template>
    <el-dialog title="预警音频" width="500px" :visible.sync="visible" class="warnTips" :modal-append-to-body="false"
        :close-on-click-modal="false">
        <div class="info">
            <img style="width: 36px;height: 36px;margin-bottom: 30px;" :src="getTipsImg(2)" alt="">
            <div style="color: #E02020">
                {{message}}
            </div>
<!--            <div :style="`color:${flag == 2 ? '#F7B500' : (flag === 'success' ? '#6D7278' : '#E02020')}`">{{ flag == 1 ?-->
<!--                '获取成功！' :-->
<!--                (flag == 2 ? '终端已离线，无法加载音频' : (flag == 3 ? '请求过于频繁，请耐心等待' : (flag == 4 ? '音频已丢失' : '加载音频超时！'))) }}-->
<!--            </div>-->
        </div>
        <!-- <div class="btn">
            <el-button class="btn1" @click="refresh">刷新</el-button>
            <el-button class="btn2" @click="visible = false">取消</el-button>
        </div> -->
    </el-dialog>
</template>
  
<script>
export default {
    components: {},
    data() {
        return {
            visible: false,
            message: "",
        };
    },
    methods: {
        refresh() {
            this.$emit('')
        },
        getTipsImg(type) {
            if (type === 2) {
                return require('@/assets/warningTips.svg');
            } else if (type === 1) {
                return require('@/assets/successTips.svg');
            } else {
                return require('@/assets/errorTips.svg');
            }
        },
    },
};
</script>
  
<style lang="less" scoped>
.warnTips {
    .info {
        display: flex;
        flex-direction: column;
        margin: 40px;
        align-items: center;
    }

    .btn {
        display: flex;
        align-items: center;
        justify-content: center;

        /deep/.el-button {
            width: 100px;
            height: 30px;
            border-radius: 2px !important;
            border-color: #44D7B6 !important;
            padding: 0;
        }

        /deep/.el-button--default {
            font-size: 14px !important;
            font-weight: 400;
            color: #44D7B6 !important;
        }

        .btn1 {
            background: rgba(68, 215, 182, 0.3) !important;
        }

        .btn2 {
            background: rgba(68, 215, 182, 0.1) !important;

        }
    }

    /deep/ .el-dialog__title {
        font-size: 18px;
    }
}

//添加动画
.flip-in-hor-bottom {
    animation: flip-in-hor-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes flip-in-hor-bottom {
    0% {
        transform: rotateX(80deg);
        opacity: 0;
    }

    100% {
        transform: rotateX(0);
        opacity: 1;
    }
}

.btn3 {
    width: 8.125rem;
    height: 1.875rem;
    background: #219E82;
    border-radius: 0.125rem;
    border: 0.0625rem solid #219E82;
    color: white;
    font-size: 0.875rem;
    cursor: pointer;
    margin: 1.875rem 1.25rem;
}

.btn3:hover {
    background: #44D7B6;
}

.btn4 {
    width: 8.125rem;
    height: 1.875rem;
    border-radius: 0.125rem;
    border: 0.0625rem solid #44D7B6;
    background: transparent;
    color: #44D7B6;
    font-size: 0.875rem;
    cursor: pointer;
    margin: 1.875rem 1.25rem;
}

.btn4:hover {
    background: #44D7B655;
}

.pane-title {
    padding-left: 30px;
    font-size: 21px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #5bb3bc;
    line-height: 32px;
}
</style>


// WEBPACK FOOTER //
// src/pages/home/realTime/warnTips.vue